import { useEffect, useState } from "react";
import { EmpresaGestora, EmpresaGestoraFiltro } from "../../../../types/EmpresaGestora";
import { useEmpresaGestora } from "../../../../hooks/useEmpresaGestora";
import FormSelectBox from "../../../../components/Form/FormSelectBox";
import FormInput from "../../../../components/Form/FormInput";
import { cargarCombo } from "../../../../services/Service";
import { toast } from "react-toastify";


export const BuscarEmpresaGestora = () => {
    const { empresaGestoraFiltroInitial, buscarEmpresasGestoras, filtro, handleFiltroEmpresaGestora } = useEmpresaGestora();
    const [filtroEmpresaGestora, setFiltroEmpresaGestora] = useState<EmpresaGestoraFiltro>(filtro);
    const [tiposDocPersona, setTiposDocPersona] = useState<any>([]);
    const [empresasGestoras, setEmpresasGestoras] = useState<EmpresaGestora[]>([]);
    const [estados] = useState<any>(
        [
            {
                'id': 'true',
                'valor': 'ACTIVA'
            },
            {
                'id': 'false',
                'valor': 'INACTIVA'
            }
        ]);

    useEffect(() => {
        cargarCombo('tiposDocPersona', setTiposDocPersona);
        cargarCombo('empresasGestoras/current', setEmpresasGestoras);
        buscarEmpresasGestoras(filtroEmpresaGestora)
            .catch((error: any) => {
                if (error?.response?.status === 403) {
                    toast.error('No tiene permisos para consultar Empresas Gestoras');
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        setFiltroEmpresaGestora({
            ...filtroEmpresaGestora,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        buscarEmpresasGestoras(filtroEmpresaGestora)
            .catch((error: any) => {
                if (error?.response?.status === 403) {
                    toast.error('No tiene permisos para consultar Empresas Gestoras');
                }
            });
        handleFiltroEmpresaGestora(filtroEmpresaGestora)
    }

    const handleClean = () => {
        setFiltroEmpresaGestora(empresaGestoraFiltroInitial);
        handleFiltroEmpresaGestora(empresaGestoraFiltroInitial);
    };

    return (

        <div className="card">
            <form id="dto" className="form-horizontal" action="buscarEmpresasGestoras" method="post">
                <div className="card-body">
                    <h4 className="m-t-0 header-title">
                        <i className="fa fa-search margin-right-7" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                        Buscar
                    </h4>
                    <hr />

                    <div className="row mt-2">

                        <FormSelectBox
                            title={'Tipo de Identificación'}
                            label={'Tipo de Identificación'}
                            id={'idTipoDocPersona'}
                            name={'idTipoDocPersona'}
                            onChange={handleChange}
                            optionId={'id'}
                            optionLabel={'tipoDocumento'}
                            value={filtroEmpresaGestora.idTipoDocPersona || ''}
                            options={tiposDocPersona}
                        />

                        <FormInput
                            id={'nroIdentificacion'}
                            label={'Número de Identificación'}
                            name={'nroIdentificacion'}
                            placeholder={'Número de Identificación'}
                            onChange={handleChange}
                            value={filtroEmpresaGestora.nroIdentificacion}
                        />

                    </div>

                    <div className="row mt-2">

                        <FormSelectBox
                            title={'Empresa Gestora'}
                            label={'empresa gestora'}
                            id={'razonSocial'}
                            name={'razonSocial'}
                            onChange={handleChange}
                            optionId={'nombreEmpresa'}
                            optionLabel={'nombreEmpresa'}
                            value={filtroEmpresaGestora.razonSocial || ''}
                            options={empresasGestoras}
                        />

                        <FormSelectBox
                            title={'Estado'}
                            label={'estado'}
                            id={'activo'}
                            name={'activo'}
                            onChange={handleChange}
                            optionId={'id'}
                            optionLabel={'valor'}
                            value={filtroEmpresaGestora.activo || ''}
                            options={estados}
                            seleccionarText="TODOS"
                        />

                    </div>

                    <hr />
                    <div className="row">
                        <div className="col-md-12 text-center">

                            <button className="btn btn-secondary btn-rounded waves-effect waves-light mr-1" type="button" id="limpiarFiltro" onClick={handleClean}>
                                <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
                                Limpiar
                            </button>
                            <button className="btn btn-success btn-rounded waves-effect waves-light " type="submit" onClick={handleSubmit}>
                                <i className="fa fa-search mr-1"></i>
                                Buscar
                            </button>

                        </div>
                    </div>

                </div>
            </form>
        </div>
    )
}
